import React, { useState, useEffect } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import { Link, useLocation } from "react-router-dom";
import Fade from "@mui/material/Fade";
import "./sideBarMenu.css";
import { useAuth } from "../../context/API_Client";
import { defaultListDate, isEmpty } from "../../pages/utils/utils";
import sideMenu from "../../../constants/sideMenu";
import { colorBrandObject } from "../../../constants/brandings";
import AlignVerticalBottomIcon from '@mui/icons-material/AlignVerticalBottom';
import ShowChartOutlined from "@mui/icons-material/ShowChartOutlined";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';

export const SideBarMenu = (props) => {
  const { sidebarCollapsed, showRecon } = props;
  const { isAuthorizedFeature, getGenericReconciliationConfig, getAllTransactionDetails, setApprovalCount, approvalCount, merchantSettings } = useAuth();
  const location = useLocation();
  const currentUrl = location.pathname;
  const [expanded, setExpanded] = useState(0);
  const [newMenu, setNewMenu] = useState([]);
  const [merchantData, setMerchantData] = useState();
  const [approvalDataLoaded, setApprovalDataLoaded] = useState(false)

  const sideBarSelectedOptionBackground = colorBrandObject?.sideBarSelectedOptionBackground || "#24b7aa";
  const sideBarSelectedOptionColor = colorBrandObject?.sideBarSelectedOptionColor || "#fff";

  const isActive = (url) => currentUrl.includes(url) ? {
    backgroundColor: sideBarSelectedOptionBackground,
    color: sideBarSelectedOptionColor,
  } : {
    color: "#6C6C6C",
  };

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  useEffect(() => {
    merchantSettings((settings) => setMerchantData(settings));

  }, [])
  const titleStyle = {
    width: sidebarCollapsed ? "0px" : "auto",
    opacity: sidebarCollapsed ? 0 : 1,
    paddingLeft: sidebarCollapsed ? "0px !important" : "0.5rem",
  };

  const checkReconAuthorization = (menuName) => {
    let permissions = menuName.split(",");
    let isRecon = permissions.includes('RECON_RECORD_FILES') || permissions.includes('RECON_REPORTS');
    let isAuthorized = isAuthorizedFeature('RECON_RECORD_FILES') || isAuthorizedFeature('RECON_REPORTS')
    return { isRecon, isAuthorized }
  }

  const getFormattedSubMenuItem = (item) => {
    const menu = item.map((d, i) => {
      if (i === 0) {
        // set the id of the menu, so that it can be retrived while navigateToAvailableRoute();
        localStorage.setItem('reconId', d.reconId)
      }
      return {
        name: 'RECON_RECORD_FILES',
        url: `/reconciliation/${d.reconId}`,
        title: d.reconName,
        icon: <AlignVerticalBottomIcon alt={d.reconName} className="iconsSize" />,
      }
    });
    return menu
  }

  useEffect(() => {
    if (!isEmpty(newMenu)) return
    const newSide = sideMenu.map(d => {
      const { isRecon, isAuthorized } = checkReconAuthorization(d.name);
      const reconConfig = localStorage.getItem("recon-config");

      if (isRecon && isAuthorized) {
        if (isEmpty(reconConfig)) {
          getGenericReconciliationConfig(onSuccess, onError)
        } else {
          onSuccess();
        }
        function onSuccess(resp) {
          d.subMenu = getFormattedSubMenuItem(isEmpty(reconConfig) ? resp : JSON.parse(reconConfig));
          d.subMenu.push({
            name: 'RECON',
            url: '/paymentReconciliation',
            title: 'Payments',
            overridePermission: true,
            icon: <ShowChartOutlined alt="Reconciliation" className="iconsSize" />,
          })
        }
        function onError(err) {
          d.subMenu = [];
        }
      }
      return d
    });
    setNewMenu(newSide);
  }, []);

  useEffect(() => {
    if (isAuthorizedFeature('REFUND_REVIEW') && merchantData?.refundReviewEnabled) {
      function getApprovalData() {

        let { fromDate, toDate } = defaultListDate()
        const filters = {
          "operationStatus": "PendingReview"
        }
        let reqData = {
          fromDate: fromDate,
          toDate: toDate,
          attributeFilters: filters,
        };
        getAllTransactionDetails(reqData, function (paymentData) {
          setApprovalCount(paymentData.totalCount);
        },
          function (errorMsg) {
            console.log("errorMsg", errorMsg);
          },
        );

      }
      getApprovalData()
    }
  }, [])

  const checkParentItemPermissions = (name) => {
    let isValid = false;
    if (isEmpty(name)) return isValid;
    if (typeof name == "string") {
      let permissions = name.split(",");
      if (permissions?.length) {
        isValid = permissions.some((el) => isAuthorizedFeature(el.trim()));
      }
    }
    return isValid;
  };

  return (
    <>
      {newMenu.map((item, index) => {
        const shouldRender = (item.name !== "RECON" && (checkParentItemPermissions(item.name) || item.overridePermission));
        if (!shouldRender) return null;
        if (item.name == "REFUND_REVIEW" && !merchantData?.refundReviewEnabled) return null
        return (
          <Accordion
            key={index}
            expanded={expanded == `${index}`}
            onChange={handleChange(index)}
            className="bg-transparent shadow-none p-0 d-grid sidebar-menu-root"
            disableGutters={true}
            defaultExpanded={currentUrl.includes(item.url)}
          >
            <AccordionSummary
              expandIcon={
                item.renderSubmenu && (
                  <>
                    {sidebarCollapsed ? (
                      <KeyboardArrowUpIcon sx={{ fontSize: '1.2rem' }} />
                    ) : (
                      <KeyboardArrowDownIcon sx={{ fontSize: '1.2rem' }} />
                    )}
                  </>
                )
              }
              aria-controls="panel1-content"
              id={`panel-${index}-header`}
              className={`p-0 rounded sidebar-summary`}
              style={!item.renderSubmenu ? isActive(item.url) : {}}
            >
              {!item.renderSubmenu ? (
                <Link to={item.url}
                  target={item.target}
                  className="sidebar-summary-text py-2 "
                >
                  <div className="sidebar-summary-div pt-0 px-3">
                    <div className="position-relative">
                      <>
                        {item.icon}
                      </>
                      {approvalCount > 0 && item.name == "REFUND_REVIEW" && <span className="notificationCount">{approvalCount}</span>}
                    </div>
                    <Fade in={!sidebarCollapsed}
                      appear={!sidebarCollapsed}
                      timeout={{
                        enter: 0,
                        exit: 500,
                      }}
                    >
                      <p className="m-0 sidebar-title-text" style={titleStyle}>
                        {item.title}
                      </p>
                    </Fade>
                  </div>
                </Link>
              ) : (
                <div className="sidebar-summary-div py-2 px-3">
                  {item.icon}
                  <Fade
                    in={!sidebarCollapsed}
                    appear={!sidebarCollapsed}
                    timeout={{
                      enter: 0,
                      exit: 500,
                    }}
                  >
                    <p className="m-0 sidebar-title-text" style={titleStyle}>
                      {item.title}
                    </p>
                  </Fade>
                </div>
              )}
            </AccordionSummary>
            {!isEmpty(item.renderSubmenu) && (
              <AccordionDetails className="p-0">
                {item.subMenu.map((subItem, subIndex) => {
                  return (
                    (isAuthorizedFeature(subItem.name) ||
                      (subItem.name === "RECON" && isAuthorizedFeature(subItem.name) && showRecon)) && (
                      <Link
                        key={subIndex}
                        to={subItem.url}
                        className={`${sidebarCollapsed ? "sidebar-ml-remove-animation " : "sidebar-ml-add-animation "}
                               ${currentUrl.includes(subItem.url) ? "sideBar-active-submenu " : ""}
                               d-flex py-2 px-3 rounded text-inherit sidebar-submenu-text align-items-center
                               `}
                        style={isActive(subItem.url)}
                      >
                        {subItem.icon}
                        <Fade
                          in={!sidebarCollapsed}
                          appear={!sidebarCollapsed}
                          timeout={{
                            enter: 0,
                            exit: 500,
                          }}
                        >
                          <p className="m-0 sidebar-title-text" style={titleStyle}>
                            {subItem.title}
                          </p>
                        </Fade>
                      </Link>
                    )
                  );
                })}
              </AccordionDetails>
            )}
          </Accordion>
        );
      })}
    </>
  );
};
